import * as ROUTES from './routes';
import { routeTutorCabinet, routeTutorProfile } from './routes';

export default [
  // Center
  ROUTES.routeCenterMain(),
  ROUTES.routeCenterNewsletters(),
  ROUTES.routeCenterServices(),
  ROUTES.routeCenterPosts(),
  ROUTES.routeCenterMoments(),

  ROUTES.routeCenterPostsTag(),
  ROUTES.routeCenterPostsCategory(),
  ROUTES.routeCenterLessons(),
  ROUTES.routeCenterLessonsTheme(),
  ROUTES.routeCenterLessonsCategory(),
  ROUTES.routeCenterVideo(),
  ROUTES.routeMainVideos(),
  ROUTES.routeProfileVideos(),
  ROUTES.routeCenterOrganisations(),
  ROUTES.routeCenterOrganisationsCategory(),
  ROUTES.routeCenterExperts(),
  ROUTES.routeCenterTutors(),
  ROUTES.routeCenterStock(),
  ROUTES.routeCenterQuestion(),
  ROUTES.routeCenterQuestions(),
  ROUTES.routeCenterQuestionsTheme(),
  ROUTES.routeCenterQuestionsCategory(),
  ROUTES.routeCenterProfile(),
  ROUTES.routeCenterBanner(),
  ROUTES.routeCenterTheme(),
  ROUTES.routeCenterVideos(),
  ROUTES.routeCenterSalesCompany(),
  ROUTES.routeCenterMyCalendar(),
  ROUTES.routeWebCenterMyCompanies(),
  ROUTES.routeCenterCabinetClient(),
  ROUTES.routeWebCompanyTimetable(),
  ROUTES.routeWebCompanyRecord(),
  ROUTES.routeWebCompanyServices(),
  ROUTES.routeCenterMyCompanies(),
  ROUTES.routeCenterMySubsriptions(),
  ROUTES.routeCenterVideoConference(),
  ROUTES.routeSchedule(),
  ROUTES.routeStudentFiles(),
  ROUTES.routeMyOrders(),
  // Membership
  ROUTES.routeMembershipProfile(),
  ROUTES.routeTutorProfile(),
  ROUTES.routeTutorCabinet(),

  // All other

  ROUTES.routeSignIn(),
  ROUTES.routeProfileEdit(),
  ROUTES.routeBalance(),
  ROUTES.routePrizeDraws(),

  ROUTES.routeCenterCompany(),
  ROUTES.routeSchool(),
  ROUTES.routePostByArticle(),
  ROUTES.routeUserByArticle(),

  ROUTES.routeTickets(),
  ROUTES.routeTicketsItems(),
  ROUTES.routeServicesGroups(),
  ROUTES.routeStudentsGroups(),
  // Profile from Moedvizh

  ROUTES.routeFormsAnswersByClient(),
  ROUTES.routeVisitsStudents(),
  ROUTES.routeActivitesStudents(),
  // ROUTES.routeFormsQuestionsByClient(),

  ROUTES.routeForms(),
  ROUTES.routeStockByCompany(),
  ROUTES.routeFormQuestions(),
  ROUTES.routeFormAnswers(),
  ROUTES.routeServices(),
  ROUTES.routeDigitalGoods(),
  // ROUTES.routeService(),
  ROUTES.routeTeachers(),
  ROUTES.routeTeacher(),
  ROUTES.routeStudents(),
  ROUTES.routeAnalytics(),
  ROUTES.routeStudent(),
  ROUTES.routeAdministrators(),
  ROUTES.routeFinance(),
  ROUTES.routeRequests(),
  ROUTES.routeWorkTimes(),
  ROUTES.routeTimetable(),
  ROUTES.routeSchoolBonuses(),
  ROUTES.routeFormsByClient(),
  ROUTES.routeFilesByClient(),
  ROUTES.routeServicesByClient(),
  ROUTES.routeVideoconferenceByCompany(),
  ROUTES.routeNotifications(),
  ROUTES.routeMembership(),
  ROUTES.routeCenterChat(),
  ROUTES.routeCenterChatMessages(),

  // Cabinet
  ROUTES.routeCabinetMain()
];
